import { render, staticRenderFns } from "./CompanyVisionPage.vue?vue&type=template&id=5a88f650&scoped=true&"
import script from "./CompanyVisionPage.vue?vue&type=script&lang=js&"
export * from "./CompanyVisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88f650",
  null
  
)

export default component.exports